import { topics } from '@/mocks/homeData';

export default function TopicsSection() {
  return (
    <section id="topics" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="mx-auto max-w-[1280px]">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
              话题标签
            </h2>
            <p className="text-sm md:text-base text-foreground-600 max-w-[560px] mx-auto">
              按题材快速筛选你感兴趣的韩国漫画，发现更多精彩作品
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
            {topics.map((topic) => (
              <a
                key={topic.name}
                href="#index"
                className="group relative flex flex-col items-center gap-2 p-5 md:p-6 rounded-xl bg-background-50 border border-background-200/60 hover:border-primary-300 hover:bg-primary-50/30 transition-all duration-300 no-underline cursor-pointer"
              >
                {topic.hot && (
                  <span className="absolute -top-2 -right-2 px-2 py-0.5 rounded-full bg-accent-500 text-background-50 text-[10px] font-bold leading-tight">
                    HOT
                  </span>
                )}
                <div className="w-12 h-12 rounded-full bg-secondary-100 flex items-center justify-center group-hover:bg-primary-100 transition-colors duration-300">
                  <i className={`${topic.icon} text-xl text-secondary-600 group-hover:text-primary-500 transition-colors duration-300`}></i>
                </div>
                <span className="text-sm font-semibold text-foreground-800">{topic.name}</span>
                <span className="text-xs text-foreground-400">{topic.count}</span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}